import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { useGetSharedFunctionality } from '../api/lending/lapiHooks';

export function useAccountNavigation() {
  const navigate = useNavigate();
  const { functionality } = useGetSharedFunctionality({
    functionalities: ['use_circe_account_pages'],
  });
  const useCirceAccountPages = !!functionality?.use_circe_account_pages;

  const navigateToAccount = useCallback(
    (queryString: string = '') => {
      if (useCirceAccountPages) {
        navigate(`/pay/account/${queryString}`);
        window.scrollTo(0, 0);
      } else {
        window.location.href = `/account/iwocapay/${queryString}`;
      }
    },
    [useCirceAccountPages, navigate],
  );

  const getAccountUrl = useCallback(
    (queryString: string = '') => {
      return useCirceAccountPages
        ? `/pay/account/${queryString}`
        : `/account/iwocapay/${queryString}`;
    },
    [useCirceAccountPages],
  );

  return { navigateToAccount, getAccountUrl, useCirceAccountPages };
}
